"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getScreenDimentionsBuilder = (args) => ({ functionId, callbacks, executeProcesses, }) => {
    const { width, height } = args.getScreenDimentions();
    executeProcesses(functionId, callbacks.success, { width, height });
};
exports.default = getScreenDimentionsBuilder;
